import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton"]

  connect() {
    this.toggleClearButton()
  }

  toggleClearButton() {
    const hasValue = this.inputTarget.value.trim() !== ""
    this.clearButtonTarget.classList.toggle("hidden", !hasValue)
  }

  clearSearch() {
    this.inputTarget.value = ""
    this.toggleClearButton()

    // Submit the form only if there was a previous search value
    if (new URLSearchParams(window.location.search).has("search")) {
      // Remove search param and redirect to base URL
      const url = new URL(window.location.href)
      url.searchParams.delete("search")
      window.location.href = url.toString()
    }
  }
}
